/**
 * Brand mark (APP-001 §15).
 *
 * Carries forward the Signup Risk brand identity into the dashboard
 * without copying the Webflow marketing layout. The mark is a restrained
 * technical glyph + wordmark; it prioritizes usability over decoration.
 */
import { ShieldAlert } from '@/components/icons';
import { cn } from '@/lib/utils';

export function BrandMark({ className, withWordmark = true }: { className?: string; withWordmark?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary text-primary-foreground">
        <ShieldAlert className="h-4 w-4" />
      </span>
      {withWordmark ? (
        <span className="text-sm font-semibold tracking-tight text-foreground">
          Signup Risk
        </span>
      ) : null}
    </span>
  );
}
